import { getStore } from "app/store/store"
import { IFormat, IFormatFilter } from "format/model"
import { formatRPO } from "format/repository"
import { normalizeSync } from "normalize-diacritics"

export const getAllFormats = (): Promise<IFormat[]> => formatRPO.getAllFormat()

export function getAllFormatsInStore(): IFormat[] {
  return getStore().getState().format.formats
}

export function getFormatById(formatId: number): IFormat | null {
  return (
    getStore()
      .getState()
      .format.formats.find(f => f.id === formatId) || null
  )
}

export const getFormatByIds = (formatIds: number[]): IFormat[] =>
  getStore()
    .getState()
    .format.formats.filter(f => formatIds.indexOf(f.id) !== -1)

export const getFilteredFormats = (filter: IFormatFilter, selectedIds: number[]): IFormat[] => {
  const nameFilter = filter.name ? normalizeSync(filter.name).toLowerCase() : ""
  return getAllFormatsInStore().filter(f => {
    if (nameFilter) {
      if (f.normalizedName.indexOf(nameFilter) === -1) {
        return false
      }
    }
    if (filter.width !== null && filter.width) {
      if (f.width !== filter.width) {
        return false
      }
    }
    if (filter.heigth !== null && filter.heigth) {
      if (f.height !== filter.heigth) {
        return false
      }
    }
    if (filter.orientation) {
      if (f.orientation !== filter.orientation) {
        return false
      }
    }
    if (typeof filter.selected === "boolean") {
      if (filter.selected) {
        if (selectedIds.indexOf(f.id) === -1) {
          return false
        }
      } else {
        if (selectedIds.indexOf(f.id) !== -1) {
          return false
        }
      }
    }
    return true
  })
}

export const getDefaultFormatFilter = (): IFormatFilter => ({
  name: "",
  heigth: null,
  width: null,
  orientation: null,
  selected: null
})
